<template>
<div class="file-instance-modal">
  <img class="close-modal" src="@/assets/images/close-modal.png" alt="" @click="closeInstanceModal"/>
  <div class="file-imgs">
    <div class="recognize-important-wrapper">
      <span>识别重点：</span>
      <div class="important-word">
        <el-scrollbar style="max-height:135px;padding-bottom:10px">
          <ul>
            <li v-for="(item,index) in ocrImportantWordArr" :key="index" :class="index == defaultInstanceIndex ? 'word-item word-item-active' : 'word-item'" @click="clickImportantWord(index)">
              {{item.focusFieldName}}
            </li>
          </ul>
        </el-scrollbar>  
      </div>
    </div>
    <div class="instance-pic-wrapper">
      <!-- <div class="instance-img">
        <el-carousel ref="carouselRef" :interval="3000" arrow="always" indicator-position="none" :autoplay="false" :loop="false" @change="changeImg">
          <el-carousel-item v-for="(item,index) in picList" :key="index">
            <div class="image-preview-mouse"
              v-mousewheelZoom
              :key="index"
              :style="{backgroundImage: 'url(' + imgOss + item.url + ')', 
              backgroundSize:'contain',
              backgroundPosition:'center',
              backgroundRepeat: 'no-repeat'}">
            </div>
          </el-carousel-item>
        </el-carousel>
        <div class="rotate-btns">
          <el-button size="mini" @click="leftRotateInstance">左旋转</el-button>
          <el-button size="mini" @click="rightRotateInstance">右旋转</el-button>
        </div>
      </div> -->
      <MultipleOptionImg :oneImg="false" :key="instanceTimer" :otherList="picList" :defaultIndex="defaultInstanceIndex" @changeInstanceArrow="changeInstanceArrow"/>
      <MultipleOptionImg :oneImg="true" :oneUrl="previewPicturesUrl"/>
      <!-- <div class="file-img">
        <div v-mousewheelZoom
          class="file-pic"
          :style="{backgroundImage: 'url(' + imgOss + currentFileUrl + ')', 
          backgroundSize:'contain',
          backgroundPosition:'center',
          backgroundRepeat: 'no-repeat'}">
        </div>
        <div class="rotate-btns">
          <el-button size="mini" @click="leftRotatePic">左旋转</el-button>
          <el-button size="mini" @click="rightRotatePic">右旋转</el-button>
        </div>
      </div> -->
    </div>
  </div>
</div>
</template>
<script>
import MultipleOptionImg from "@/components/MultipleOptionImg.vue";
// import { getPatientFocusFieldPage,disableInvalid,readOtherEntry,markFocus } from "@/api/crossreentry"
export default {
  components: {
    MultipleOptionImg
  },
  props: {
    showLookPic: {
      type: Boolean,
      default: false
    },
    showInstance: {
      type: Boolean,
      default: false
    },
    previewPicturesUrl: {
      type: String
    },
    ocrImportantWordArr: {
      type:Array,
      default:()=>[]
    }
  },  
  data() {
    return {
      selectWordIndex: 0,
      instanceTimer: 0,
      defaultInstanceIndex: 0,
      imgOss: process.env.VUE_APP_OSS_URL, //图片公用拼接地址
      picList: [],
      currentFileUrl: 'dsicm-medical/f1031b9ef80748d3adfaa1e2c35ea059.jpg'
    }
  },
  async created() {
    this.ocrImportantWordArr.forEach((v,index) => {
      this.picList.push({
        url: v.billDemo,
        imgIndex: index
      })
    })
  },
  mounted() {},
  methods: {
    changeInstanceArrow(defaultAddImgIndex) {
      this.defaultInstanceIndex = defaultAddImgIndex
    },
    clickImportantWord(index) {
      this.instanceTimer++
      this.defaultInstanceIndex = index
      console.log(this.defaultInstanceIndex)
    },
    closeInstanceModal() {
      this.$emit('handleCloseInstance')
    }
    // leftRotateInstance() {
    //   let selectImgNode = document.getElementsByClassName("image-preview-mouse")[this.defaultAddImgIndex]
    //   // console.log(selectImgNode)
    //   this.rotateCountDeg = this.rotateCountDeg - 90
    //   selectImgNode.style.rotate = this.rotateCountDeg + 'deg'
    // },
    // rightRotateInstance() {
    //   let selectImgNode = document.getElementsByClassName("image-preview-mouse")[this.defaultAddImgIndex]
    //   this.rotateCountDeg = this.rotateCountDeg + 90
    //   selectImgNode.style.rotate = this.rotateCountDeg + 'deg'
    // },
    // leftRotatePic() {
    //   let selectImgNode = document.getElementsByClassName("image-preview-mouse")[this.defaultAddImgIndex]
    //   // console.log(selectImgNode)
    //   this.rotateCountDeg = this.rotateCountDeg - 90
    //   selectImgNode.style.rotate = this.rotateCountDeg + 'deg'
    // },
    // rightRotatePic() {
    //   let selectImgNode = document.getElementsByClassName("image-preview-mouse")[this.defaultAddImgIndex]
    //   this.rotateCountDeg = this.rotateCountDeg + 90
    //   selectImgNode.style.rotate = this.rotateCountDeg + 'deg'
    // },
    // changeImg() {
      
    // },
  }
};
</script>
<style lang="less" scoped>
/deep/ .el-scrollbar .el-scrollbar__wrap{
  padding-bottom: 13px;
  max-height: 135px;
}
.file-instance-modal {
  width: 100%;
  height: 92vh;
  background: rgba(51,51,51,0.95);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 68;
  padding: 80px 50px;
  font-size: 14px;
  margin-top: 50px;
  padding-bottom:100px;
  .close-modal {
    width: 32px;
    height: 32px;
    position: absolute;
    top: 15px;
    right: 15px;
  }
  .file-imgs {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  .recognize-important-wrapper {
    color: #FFFFFF;
  }
  .important-word {
    margin-top: 20px;
    padding: 10px 20px;
    // max-height:135px;
    ul {
      display: flex;
      flex-wrap: wrap;
      // max-height: 125px;
      // overflow: auto;
      // padding: 10px 20px;
    }
    .word-item {
      padding: 10px;
      cursor: pointer;
    }
    .word-item-active {
      background: #1A7BFC;
      border-radius: 15px;
    }
  }
  .instance-pic-wrapper {
    width: 100%;
    // height: calc(100% - 106px);
    display: flex;
    // margin-top: 14px;
    margin-top: 6px;
    flex: 1;
    .instance-img,.file-img {
      width: 50%;
      // height: 600px;
    }
    .file-img-png {
      height: 100%;
      overflow: hidden;
    }
    .file-pic {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 50%;
      height: 100%;
      position: relative; /*定位*/
      // top: -20px;
      top: 0px;
      left: 0px;
      // overflow: hidden;
    }
    .image-preview-mouse {
      display: flex;
      justify-content: center;
      align-items: center;
      // width: 490px;
      height: 100%;
      position: relative; /*定位*/
      // top: -20px;
      top: 0px;
      left: 0px;
    }
    .rotate-btns {
      text-align: center;
      margin-top: 48px;
    }
  }
}
</style>